import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">

      <p class="poem-block mb-3">
        Vidis mi montojn Krimeajn, la rokojn en verda ornamo, <br/>
        Pinoj en suna jubil’ verdbrilis sur blua ondar’. <br/>
        Maro senlima, senvoja trasternas la ondojn trankvilajn <br/>
        Vaste al la malproksim’ diafana de la horizont’.
      </p>

      <p class="poem-block mb-3">
        Preter patosaj ruĝgrundaj rokaroj de la Karadago <br/>
        Naĝis mi, vidis mi golfojn senhomajn en plena sunbril’. <br/>
        Nure la rokoj, la maro, la suno kaj mi inter ili – <br/>
        Jen pintopunkt’ de l’ feliĉ’, plenumo de ĉiu dezir’.
      </p>

      <p class="poem-block mb-5">
        Estis facila revoj’ surdekliva el la Nova Mondo, <br/>
        Kvazaŭ piedoj min mem tiris al mond’ sen apog’. <br/>
        Baldaŭ revenos mi al mia hejm’ sen kompat’ kaj espero; <br/>
        Tie, en plena mallum’, brilos en mi rememor’.
      </p>

      <p class="poem-block mb-3">
        Estis mi en atelier’ de l’ Pentristo en la Koktebelo; <br/>
        Ĉu en la sama domet’ ne loĝis mi antaŭ centjar’? <br/>
        Ĉio konata al mi: jen libraro, jen farboj, skulptaĵoj, <br/>
        Lito, plenombra spegul’ kaj busto de la Taiah’.
      </p>

      <p class="poem-block mb-3">
        Sunradiita aer’ plenplenigis la ĉambron malgrandan, <br/>
        Tamen senliman – ja ni vidas kunligon de l’ temp’. <br/>
        Tra tiuj libroj la ĉen’ etendiĝas ĝis la antikveco; <br/>
        Antaŭlasta ĉener’ estas l’ Pentrist’, lasta – mi.
      </p>

      <p class="poem-block mb-3">
        Poste mi tiel libere naĝadis ĉe la Karadago, <br/>
        Jen kunfandiĝ’ kun natur’, dissolvo en plena kviet’. <br/>
        Min ne danĝeros la viv’ dum almenaŭ la jaro proksima; - <br/>
        Baptis min ĉe Karadag’ ondoj sunvarmaj de l’mar’.
      </p>
    </div>
    `
  )
}


const itemName = {
  esp: 'Krimeaj gekzametroj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;